import React from "react";
import { Link, Outlet } from "react-router-dom";
import Header from "../Components/Header";
// import "./UserLayout.css"; // Assuming you've added some styles

const UserLayout = () => {
  return (
    <div>
      <div>
        <Header />

        <div className="content mt-12 ">
          <Outlet /> {/* This is where child components will be rendered */}
        </div>
      </div>
    </div>
  );
};

export default UserLayout;
